/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponseContactSoftDeleteByPhoneResult } from '../../models/api-response-contact-soft-delete-by-phone-result';
import { ContactSoftDeleteByPhoneRequest } from '../../models/contact-soft-delete-by-phone-request';

export interface SoftDeleteContactsByPhoneNumber$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
      body: ContactSoftDeleteByPhoneRequest
}

export function softDeleteContactsByPhoneNumber(http: HttpClient, rootUrl: string, params: SoftDeleteContactsByPhoneNumber$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseContactSoftDeleteByPhoneResult>> {
  const rb = new RequestBuilder(rootUrl, softDeleteContactsByPhoneNumber.PATH, 'post');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponseContactSoftDeleteByPhoneResult>;
    })
  );
}

softDeleteContactsByPhoneNumber.PATH = '/v1/api/ui/contacts/delete-by-phone';
